import { type PropsWithChildren } from 'react';
import { assertDefined } from '@epihub/core/src/fn/assert';
import { _get } from '@epihub/core/src/fn/object';
import { promise } from '@epihub/core/src/fn/promise';
import { expectWebDeps } from '@epihub/web/src/_ctx/deps';
import { type NotificationData, type PlatformAgnosticSnackbarAPI } from '../snackbar';

export function createWebSnackbarProvider() {
  const Notifications = assertDefined(
    _get(expectWebDeps().snackbars, 'Notifications'),
    '@mantine/notifications missing Notifications component',
  );

  return ({ children }: PropsWithChildren) => (
    <>
      <Notifications />
      {children}
    </>
  );
}

export function createWebSnackbars() {
  const notifications = assertDefined(
    _get(expectWebDeps().snackbars, 'notifications'),
    '@mantine/notifications missing notifications API',
  );

  return {
    show(notification: NotificationData) {
      return promise((resolve) => {
        notifications.show({
          ...notification,
          onOpen: async (...rest) => {
            notification?.onOpen?.(notification, ...rest);
            resolve();
          },
          onClose: async (...rest) => {
            await notification?.onClose?.(notification, ...rest);
            resolve();
          },
        });
      });
    },
    update(id: string, notification: Omit<NotificationData, 'id'>) {
      notifications.update({
        id,
        ...notification,
        onOpen: async (...rest) => {
          notification?.onOpen?.(notification, ...rest);
        },
        onClose: async (...rest) => {
          await notification?.onClose?.(notification, ...rest);
        },
      });
    },
    hide(id: string) {
      notifications.hide(id);
    },
    clearAll() {
      notifications.cleanQueue();
      notifications.clean();
    },
  } satisfies PlatformAgnosticSnackbarAPI;
}

// export function Snackbar({ children }: PropsWithChildren) {
//   const mapVariantToState = useMapVariantToState();
//   useEffect(() => {
//     const { unsubscribe } = ReactEmitter.listen(openEvent({}), (data) => {
//       snackbars.show({
//         ...data,
//         ...mapVariantToState(data?.variant),
//       });
//     });
//     return unsubscribe;
//   }, [mapVariantToState]);
//
//   return (
//     <Root>
//       <Notifications />
//       {children}
//     </Root>
//   );
// }
//
// const Root = styled.div`
//
// `;

// export const snackbars = {
//   ...notifications,
//   open: (param: Parameters<typeof notifications['show']>[0]) => {
//     ReactEmitter.send(openEvent, param);
//   },
// };

// function useMapVariantToState() {
//   const theme = useTheme();
//   return useCallback((variant?: string) => {
//     if (variant === 'error') {
//       return {
//         color: theme.col.error.name,
//       };
//     }
//
//     if (variant === 'success') {
//       return {
//         color: theme.col.success.name,
//       };
//     }
//
//     return {};
//   }, [theme]);
// }

// const classNames = {
//   root: css`
//     background-color: var(--notification-color, var(--mantine-primary-color-filled));
//     &::before {
//       background-color: var(--mantine-color-white);
//     }
//
//     .description,
//     .title {
//       color: var(--mantine-color-white);
//     }
//
//     .closeButton {
//       color: var(--mantine-color-white);
//
//       @mixin hover {
//         background-color: rgba(0, 0, 0, 0.1);
//       }
//     }
//   `,
//   title: css`
//     color: var(--mantine-color-white);
//   `,
//   description: css`
//     color: var(--mantine-color-white);
//   `,
//   closeButton: css`
//     color: var(--mantine-color-white);
//     @mixin hover {
//       background-color: rgba(0, 0, 0, 0.1);
//     }
//   `,
// };
